module.exports = __webpack_public_path__ + "static/subset-UniNeueHeavy-Italic-053526574bac8809284c529c04a6838d.woff";